'use memo'

import { useQueries } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { getPlayerHighlights } from '@sportninja/common/services/player/highlightServices'
import { PlayerHighlight } from '../../../pages/Player/types'
import { ProfileIdentifier } from '../types'

const PLAYER_HIGHLIGHTS_STALE_TIME = 2 * 60 * 1000

/**
 * Loads highlights for all player profiles linked to the current user.
 * A user account can have multiple linked player profiles (see /users/me/players3).
 */
export const useProfileHighlights = (
  playerIds: ProfileIdentifier[],
  enabled: boolean = true
) => {
  const queries = useQueries({
    queries: playerIds.map((playerId) => ({
      queryKey: queryKeys.playerHighlights.byPlayer(String(playerId)),
      queryFn: () => getPlayerHighlights(playerId),
      enabled: enabled && Boolean(playerId),
      staleTime: PLAYER_HIGHLIGHTS_STALE_TIME,
    })),
  })

  const highlights = queries.flatMap(
    (query) => (query.data ?? []) as PlayerHighlight[]
  )
  const loading = queries.some((query) => query.isPending)

  return { highlights, loading }
}
